export default __webpack_public_path__ + "static/media/altovita.50766786.ico";